<div [ngClass]="{ 'px-0': isMessagePage(), 'container-md mt-3': true }">
  <!-- Date -->
  <div
    [ngClass]="[
      isMessagePage()
        ? 'message__word--medium-screen mx-0'
        : 'article__word--medium-screen',
      'row'
    ]"
    *ngIf="
      idEventNow() == -1 &&
      !selectedAuction().buyItNow &&
      selectedAuction().hasReservePrice
    "
  >
    <div [ngClass]="{ 'px-0': isMessagePage(), 'info col-4 col-xxl-3': true }">
      {{
        (timeDifferenceFromStart() > 0 ? "IDS_EXPIRATION" : "IDS_START")
          | translate
      }}
    </div>

    <div class="col text-box-info">
      <fa-icon [icon]="faCalendarAlt" size="sm" class="calendar-icon me-2" />

      <span class="divider">
        {{
          (timeDifferenceFromStart() > 0
            ? selectedAuction().endDateView
            : selectedAuction().startDateView
          ) | date : "dd/MM/yyyy ore HH:mm"
        }}
      </span>

      <span class="fw-bold text-nowrap" *ngIf="!isMessagePage()">
        <span
          class="text-danger text-uppercase"
          *ngIf="
            selectedAuction().isFinished &&
            secondsToEnd() < 0 &&
            timeDifferenceFromStart() > 0
          "
        >
          {{ "IDS_EXPIRED" | translate }}
        </span>

        <span *ngIf="secondsToEnd() >= 0">
          <span class="text-success" *ngIf="daysToEnd() > 0">
            {{ daysToEnd() }}
            {{ (daysToEnd() === 1 ? "IDS_DAY" : "IDS_DAYS") | translate }},
            {{ hoursToEnd() }}
            {{ (hoursToEnd() === 1 ? "IDS_HOUR" : "IDS_HOURS") | translate }}
          </span>

          <span class="text-danger" *ngIf="daysToEnd() === 0 && hoursToEnd() > 0">
            {{ hoursToEnd() }}
            {{ (hoursToEnd() === 1 ? "IDS_HOUR" : "IDS_HOURS") | translate }},
            {{ minutesToEnd() }}
            {{
              (minutesToEnd() === 1 ? "IDS_MINUTE" : "IDS_MINUTES") | translate
            }}
          </span>

          <span class="text-danger" *ngIf="daysToEnd() === 0 && hoursToEnd() === 0">
            {{ minutesToEnd() }}
            {{
              (minutesToEnd() === 1 ? "IDS_MINUTE" : "IDS_MINUTES") | translate
            }}, {{ secondsToEnd() }}
            {{
              (secondsToEnd() === 1 ? "IDS_SECOND" : "IDS_SECONDS") | translate
            }}
          </span>
        </span>
      </span>
    </div>
  </div>

  <!-- Quantity -->
  <div
    [ngClass]="[
      isMessagePage()
        ? 'message__word--medium-screen mx-0'
        : 'article__word--medium-screen',
      'row mt-3 align-items-center'
    ]"
    *ngIf="
      selectedAuction().buyItNow &&
      selectedAuction().articleQty === 0 &&
      idEventNow() === -1
    "
  >
    <div [ngClass]="{ 'px-0': isMessagePage(), 'info col-4 col-xxl-3': true }">
      <span>
        {{ "IDS_QUANTITY" | translate }}
      </span>
    </div>
    <!-- Disabled by parent if statement - original condition ... && selectedAuction().articleQty < 99  -->
    <div class="col" *ngIf="selectedAuction().articleQty > 0">
      <span [ngClass]="{ 'message__text-start': isMessagePage(), price: true }">
        {{ selectedAuction().articleQty }}
      </span>
    </div>
    <div
      class="col d-flex align-items-center"
      *ngIf="selectedAuction().articleQty === 0"
    >
      <span
        [ngClass]="{
          'message__text-start': isMessagePage(),
          'price text-danger text-uppercase text-box-info fw-bold': true
        }"
      >
        {{ "IDS_SOLD_OUT" | translate }}
      </span>
    </div>
  </div>

  <!-- Sold out -->
  <div
    [ngClass]="[
      isMessagePage()
        ? 'message__word--medium-screen mx-0'
        : 'article__word--medium-screen',
      'row mt-3 align-items-center justify-content-center text-align-center'
    ]"
    *ngIf="
      selectedAuction().buyItNow &&
      selectedAuction().articleQty === 0 &&
      idEventNow() !== -1 &&
      selectedAuction().articleQty === 0
    "
  >
    <span
      [ngClass]="{
        'message__text-start': isMessagePage(),
        'text-success text-uppercase text-box-info fw-bold awarded-text': true
      }"
    >
      {{ "IDS_AWARDED_AUCTION_1" | translate }}
    </span>
  </div>

  <!-- Base auction price -->
  <div
    [ngClass]="[
      isMessagePage()
        ? 'message__word--medium-screen mx-0'
        : 'article__word--medium-screen',
      'row mt-3 align-items-center'
    ]"
    *ngIf="!selectedAuction().buyItNow && selectedAuction().hasReservePrice"
  >
    <div [ngClass]="{ 'px-0': isMessagePage(), 'info col-4 col-xxl-3': true }">
      <span>
        {{
          (selectedAuction().currentMaxOfferedPrice !== null &&
          selectedAuction().currentMaxOfferedPrice > 0
            ? "IDS_LAST_BID"
            : "IDS_BASE_PRICE"
          ) | translate
        }}
      </span>
    </div>
    <div class="col">
      <span [ngClass]="{ 'message__text-start': isMessagePage(), price: true }">
        {{
          selectedAuction().currentMaxOfferedPrice !== null &&
          selectedAuction().currentMaxOfferedPrice > 0
            ? selectedAuction().currentMaxOfferedPrice
            : selectedAuction().basePrice
        }}
        €
      </span>
    </div>
  </div>

  <!-- Buy now price -->
  <div
    [ngClass]="[
      isMessagePage()
        ? 'message__word--medium-screen mx-0'
        : 'article__word--medium-screen',
      'row mt-3 align-items-center'
    ]"
    *ngIf="selectedAuction().buyItNow === true"
  >
    <div [ngClass]="{ 'px-0': isMessagePage(), 'info col-4 col-xxl-3': true }">
      <span class="info">
        {{ "IDS_PRICE" | translate }}
      </span>
    </div>
    <div class="col">
      <span [ngClass]="{ 'message__text-start': isMessagePage(), price: true }">
        {{ selectedAuction().basePrice }} €
      </span>
    </div>
  </div>

  <!-- Reserve -->
  <div
    [ngClass]="[
      isMessagePage()
        ? 'message__word--medium-screen mx-0'
        : 'article__word--medium-screen',
      'row mt-3 align-items-center'
    ]"
    *ngIf="
      idEventNow() == -1 &&
      timeDifferenceFromStart() > 0 &&
      !selectedAuction().buyItNow &&
      selectedAuction().hasReservePrice &&
      authService.isAuthenticated() &&
      selectedAuction().currentUserOffered
    "
  >
    <div
      [ngClass]="{ 'px-0': isMessagePage(), 'info col-4 col-xxl-3': true }"
    >
      <span>
        {{ "IDS_RESERVE" | translate }}
      </span>
    </div>
    <div class="col">
      <span
        [ngClass]="{ 'message__text-start': isMessagePage(), 'times text': true }"
        *ngIf="!selectedAuction().reservePriceReached"
      >
        <fa-icon [icon]="faTimesCircle" />
        &nbsp;
        {{ "IDS_RESERVE_NOT_REACHED" | translate }}
      </span>
      <span
        [ngClass]="{ 'message__text-start': isMessagePage(), 'check text': true }"
        *ngIf="selectedAuction().reservePriceReached"
      >
        <fa-icon [icon]="faCheckCircle" />
        &nbsp;
        {{ "IDS_RESERVE_REACHED" | translate }}
      </span>
    </div>
  </div>

  <div
    class="col-12 row mt-4"
    [ngClass]="{
      'article__word--medium-screen': !isMessagePage(),
      'message__word--medium-screen': isMessagePage(),
      'mx-0': isMessagePage()
    }"
    *ngIf="
      timeDifferenceFromStart() > 0 &&
      !selectedAuction().buyItNow
    "
  >
    <div class="info col-4 col-xxl-3" [ngClass]="{ 'px-0': isMessagePage() }">
      {{ "IDS_BIDS" | translate }}
    </div>
    <div class="col">
      <a
        [routerLink]=""
        class="offers"
        (click)="offersDialog()"
        [class.gold]="isMemorabid() && !inPreEventStatus()"
        [class.marketplace]="!isMemorabid() && !inPreEventStatus()"
        [class.preEvent]="inPreEventStatus()"
        [class.no-pointer]="isMessagePage()"
        [class.message__text-start]="isMessagePage()"
      >
        {{ selectedAuction().totalBids }} {{ "IDS_BIDS" | translate }} |
        {{ selectedAuction().totalBidder }}
        {{ "IDS_BIDDERS" | translate }}
      </a>
    </div>
  </div>
</div>
<div
  class="container-md"
  *ngIf="(timeDifferenceFromStart() > 0 || isPreEventFinished()) && !isMessagePage()"
>
  <div
    class="row mt-3 grey-background--mobile"
    *ngIf="
      (selectedAuction().rebidMaxOfferPrice == null ||
        selectedAuction().rebidMaxOfferPrice <=
          selectedAuction().currentMaxOfferedPrice) &&
      !selectedAuction().isFinished &&
      !isPreEventFinished() &&
      selectedAuction().buyItNow == false
    "
  >
    <div class="col-md-6 col-lg-8 grey-background pt-2 pb-2">
      <form (ngSubmit)="makeBidFromForm(f)" #f="ngForm">
        <label
          [class.gold]="isMemorabid() && !inPreEventStatus()"
          [class.marketplace]="!isMemorabid() && !inPreEventStatus()"
          [class.preEvent]="inPreEventStatus()"
          for="bid"
          class="text-uppercase mt-1 price-text"
        >
          {{ "IDS_INSERT_AMOUNT" | translate }}
        </label>
        <input
          type="text"
          id="bid"
          class="form-control mt-2"
          ngModel
          name="bid"
          mask="separator.0"
          placeholder="€"
          thousandSeparator="."
          suffix=" €"
          required
          pattern="^[1-9]+[0-9]*$"
          #bid
        />
        <button
          type="submit"
          class="mt-4 pt-2 pb-2 text-uppercase btn-raises"
          [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-preEvent]="inPreEventStatus()"
          [disabled]="!f.valid || f.value.bid < minimumOffer()"
        >
          {{ "IDS_RAISES" | translate }}
        </button>
      </form>
    </div>
    <div class="col-md-6 col-lg-4 pb-2">
      <div class="auto-bid--mobile">
        <div class="auto-raises--mobile">
          <div>
            <p
              [class.gold]="isMemorabid() && !inPreEventStatus()"
              [class.marketplace]="!isMemorabid() && !inPreEventStatus()"
              [class.preEvent]="inPreEventStatus()"
              class="text-uppercase mt-1 price-text"
            >
              {{ "IDS_MINIMUM_RAISE" | translate }}
            </p>
          </div>
          <div class="center-minimum-bid mt-2">
            <button
              type="button"
              (click)="makeBid(minimumOffer())"
              [class.gold-minimum-bid]="isMemorabid() && !inPreEventStatus()"
              [class.marketplace-minimum-bid]="
                !isMemorabid() && !inPreEventStatus()
              "
              [class.preEvent-minimum-bid]="inPreEventStatus()"
              class="btn-minimum-bid text-uppercase"
            >
              {{ minimumOffer() }} €
            </button>
          </div>
        </div>
        <button
          type="button"
          [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-preEvent]="inPreEventStatus()"
          class="btn-auto--mobile mt-4 pt-2 pb-2 text-uppercase btn-raises"
          (click)="makeAutoBid()"
        >
          {{ "IDS_AUTO_RAISE" | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Buy now button -->
  <div
    class="row mt-3"
    *ngIf="
      selectedAuction().rebidMaxOfferPrice == null &&
      !selectedAuction().isFinished &&
      !isPreEventFinished() &&
      selectedAuction().buyItNow == true &&
      selectedAuction().articleQty > 0
    "
  >
    <div class="col-12 col-lg-8 pt-2 pb-2">
      <form
        (ngSubmit)="makeBidFormByuNow()"
        #f="ngForm"
        class="w-full buy-now-button-alignment"
      >
        <button
          type="submit"
          class="pt-2 pb-2 text-uppercase btn-raises"
          [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-preEvent]="inPreEventStatus()"
          style="border-radius: 10rem"
        >
          {{ "IDS_BUY_NOW" | translate }}
        </button>
      </form>
    </div>
  </div>
  <div
    class="mt-3 pt-4 pb-2"
    *ngIf="
      selectedAuction().rebidMaxOfferPrice > 0 &&
      !selectedAuction().isFinished &&
      !isPreEventFinished() &&
      selectedAuction().buyItNow == false &&
      selectedAuction().rebidMaxOfferPrice >
        selectedAuction().currentMaxOfferedPrice
    "
  >
    <div class="row">
      <div
        class="col autobid-activated"
        [class.gold]="isMemorabid() && !inPreEventStatus()"
        [class.marketplace]="!isMemorabid() && !inPreEventStatus()"
        [class.preEvent]="inPreEventStatus()"
      >
        <fa-icon [icon]="faLock" size="lg" class="lock-icon"></fa-icon>
        <span class="mx-1 px-1 autobid-activated-label text-uppercase">{{
          "IDS_AUTOMATIC_RAISE_ACTIVATED" | translate
        }}</span>
      </div>
    </div>
    <div
      class="row align-items-end"
      [ngClass]="{
        'article__word--medium-screen': !isMessagePage(),
        'message__word--medium-screen': isMessagePage()
      }"
    >
      <div class="info col-4 col-xxl-3">
        {{ "IDS_LAST_BID" | translate }}
      </div>
      <div class="col">
        <span class="price"> {{ selectedAuction().rebidMaxOfferPrice }} € </span>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-7 col-sm-4 col-md-7 col-xxl-4">
        <button
          type="submit"
          class="pt-2 pb-2 text-uppercase btn-raises"
          [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-preEvent]="inPreEventStatus()"
          (click)="makeAutoBid()"
        >
          {{ "IDS_CHANGE_AMOUNT" | translate }}
        </button>
      </div>
      <div class="col-5 col-sm-4 col-md-5 col-xxl-4">
        <button
          type="submit"
          class="pt-2 pb-2 text-uppercase btn-raises"
          [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
          [class.btn-raises-preEvent]="inPreEventStatus()"
          (click)="deleteAutoRebid(selectedAuction().idAutoRebid)"
        >
          {{ "IDS_BTN_ABORT" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="row mt-5" *ngIf="!selectedAuction().buyItNow == true">
    <div class="col">
      <div
        class="row user-won grey-background"
        *ngIf="
          (selectedAuction().isFinished &&
            selectedAuction().idUserWinner == authService.userLogged.idUser) ||
          (isPreEventFinished() &&
            !!selectedAuction().preEventIdUserWinner &&
            selectedAuction().preEventIdUserWinner ==
              authService.userLogged.idUser)
        "
      >
        <div class="col pt-4 pb-2 px-4">
          <div>
            <span class="fw-bold text-uppercase grey-text text">{{
              inPreEventStatus()
                ? ("IDS_PRE_EVENT_AUCTION_IS_CLOSED" | translate)
                : ("IDS_AUCTION_IS_CLOSED" | translate)
            }}</span>
          </div>
          <div>
            <fa-icon [icon]="faGavel" size="lg"></fa-icon>
            <span class="fw-bold text-uppercase ms-2 finish-big-text">{{
              inPreEventStatus()
                ? ("IDS_YOU_WON_PRE_EVENT_AUCTION" | translate)
                : ("IDS_YOU_WON" | translate)
            }}</span>
          </div>
          <div class="mt-1">
            <span class="text">{{
              isPreEventFinished()
                ? ("IDS_EVENT_AUCTION_REMINDER" | translate)
                : ("IDS_COMPLETE_ASSIGNMENT" | translate)
            }}</span>
          </div>
          <div class="mt-3">
            <span class="fw-bold finish-big-text"
              >{{
                isPreEventFinished()
                  ? selectedAuction().preEventWinnerPrice
                  : selectedAuction().winnerPrice
              }}
              €</span
            >
          </div>
          <button
            *ngIf="!isPreEventFinished()"
            type="button"
            class="my-3 py-2 px-5 fw-bold text-uppercase btn-pay"
            [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
            [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
            [class.btn-raises-preEvent]="inPreEventStatus()"
            routerLink="/account/my-auctions/awarded"
          >
            {{ "IDS_GO_TO_AWARDED" | translate }}
          </button>
        </div>
      </div>
      <div
        class="row user-lost grey-background"
        *ngIf="
          (selectedAuction().isFinished &&
            selectedAuction().idUserWinner != authService.userLogged.idUser) ||
          (isPreEventFinished() &&
            selectedAuction().preEventIdUserWinner !=
              authService.userLogged.idUser)
        "
      >
        <div
          class="col pt-4 pb-2 px-4"
          *ngIf="
            (!inPreEventStatus() && selectedAuction().idUserWinner == null) ||
            (inPreEventStatus() && selectedAuction().preEventIdUserWinner == null)
          "
        >
          <span
            class="times text"
            *ngIf="
              selectedAuction().hasReservePrice &&
              !selectedAuction().reservePriceReached &&
              selectedAuction().buyItNow == false
            "
          >
            <fa-icon [icon]="faTimesCircle"></fa-icon>
            &nbsp;
            {{ "IDS_RESERVE_NOT_REACHED" | translate }}
          </span>
          <div>
            <fa-icon [icon]="faGavel" size="lg"></fa-icon>
            <span class="fw-bold text-uppercase ms-2 mt-2 finish-big-text">
              {{
                inPreEventStatus()
                  ? ("IDS_PRE_EVENT_AUCTION_IS_CLOSED" | translate)
                  : ("IDS_AUCTION_IS_CLOSED" | translate)
              }}
            </span>
          </div>
          <div class="mt-1 mb-3">
            <span class="text">{{
              "IDS_ARTICLE_NOT_AWARDED" | translate
            }}</span>
          </div>
          <div
            *ngIf="
              selectedAuction().buyItNow == false &&
              authService.isAuthenticated() &&
              selectedAuction().currentMaxIDUserBidder ==
                authService.userLogged.idUser &&
              selectedAuction().hasReservePrice &&
              !selectedAuction().reservePriceReached
            "
          >
            <div class="mt-1" *ngIf="timeDifference() > -172800000">
              <span class="text">{{ "IDS_YOU_CAN_OFFER" | translate }}</span>
            </div>
            <div class="my-1" *ngIf="timeDifference() <= -172800000">
              <span class="text">{{
                "IDS_RESERVE_PRICE_OFFER_END_TIME" | translate
              }}</span>
            </div>
            <div class="mt-3" *ngIf="timeDifference() > -172800000">
              <span
                class="fw-bold finish-big-text"
                *ngIf="
                  selectedAuction().currentMaxOfferedPrice != null &&
                  selectedAuction().currentMaxOfferedPrice > 0
                "
              >
                {{ selectedAuction().currentMaxOfferedPrice }} €
              </span>
              <span
                class="fw-bold finish-big-text"
                *ngIf="
                  selectedAuction().currentMaxOfferedPrice == null ||
                  selectedAuction().currentMaxOfferedPrice == 0
                "
              >
                {{ selectedAuction().basePrice }} €
              </span>
            </div>
            <button
              type="button"
              *ngIf="timeDifference() > -172800000"
              class="my-3 btn-raises-gold py-2 px-5 fw-bold text-uppercase btn-pay"
              (click)="makeBidReservePrice()"
            >
              {{ "IDS_MAKE_RESERVE_PRICE_OFFER" | translate }}
            </button>
          </div>
        </div>

        <div
          class="col pt-4 pb-2 px-4"
          *ngIf="
            (!isPreEventFinished() && selectedAuction().idUserWinner != null) ||
            (isPreEventFinished() && selectedAuction().preEventIdUserWinner != null)
          "
        >
          <div>
            <fa-icon [icon]="faGavel" size="lg"></fa-icon>
            <span class="fw-bold text-uppercase ms-2 finish-big-text">
              {{
                isPreEventFinished()
                  ? ("IDS_PRE_EVENT_AUCTION_IS_CLOSED" | translate)
                  : ("IDS_AUCTION_IS_CLOSED" | translate)
              }}
            </span>
          </div>
          <div class="mt-1">
            <span class="text"
              >{{ "IDS_AWARDED_TO" | translate
              }}<b>{{
                isPreEventFinished()
                  ? selectedAuction().preEventWinnerUsername
                  : selectedAuction().winnerUsername
              }}</b></span
            >
          </div>
          <div class="mt-1 mb-3">
            <span class="text">{{ "IDS_VALUE" | translate }}:</span>
            <span class="fw-bold finish-big-text ms-1"
              >{{
                isPreEventFinished()
                  ? selectedAuction().preEventWinnerPrice
                  : selectedAuction().winnerPrice
              }}
              €</span
            >
          </div>
          <!--<div class="mt-3">
                        <label class="text">{{'IDS_YOU_CAN_CONTACT_PART1' | translate}}{{ selectedAuction().winnerUsername }}{{'IDS_YOU_CAN_CONTACT_PART2' | translate}}</label>
                    </div>
                    <button
                        type="button"
                        [ngClass]="{'btn-raises-gold':isMemorabid(), 'btn-raises-marketplace':!isMemorabid()}"
                        class="my-3 py-2 px-5 fw-bold text-uppercase btn-pay">
                        {{'IDS_MAKE_DIRECT_OFFER' | translate}}
                    </button>-->
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!selectedAuction().buyItNow == true">
    <button
      type="button"
      *ngIf="
        selectedAuction().isFinished &&
        selectedAuction().isVisible &&
        selectedAuction().article.idCategory != 3 &&
        (timeDifference() <= -172800000 || selectedAuction().totalBids == 0) &&
        !selectedAuction().reservePriceReached &&
        authService.userLogged.idUser != selectedAuction().idUserWinner
      "
      (click)="makeOfferMessage()"
      [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
      [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
      [class.btn-raises-preEvent]="inPreEventStatus()"
      class="my-3 py-2 px-5 fw-bold text-uppercase btn-pay"
    >
      {{ "IDS_MAKE_DIRECT_OFFER" | translate }}
    </button>
    <button
      type="button"
      *ngIf="
        selectedAuction().isFinished &&
        selectedAuction().isVisible &&
        selectedAuction().article.idCategory != 3 &&
        selectedAuction().reservePriceReached &&
        authService.userLogged.idUser != selectedAuction().idUserWinner
      "
      (click)="makeOfferMessage()"
      [class.btn-raises-gold]="isMemorabid() && !inPreEventStatus()"
      [class.btn-raises-marketplace]="!isMemorabid() && !inPreEventStatus()"
      [class.btn-raises-preEvent]="inPreEventStatus()"
      class="my-3 py-2 px-5 fw-bold text-uppercase btn-pay"
    >
      {{ "IDS_MAKE_DIRECT_OFFER" | translate }}
    </button>
  </div>
</div>
